import React, { FC, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { capitalize } from 'lodash';

import { FeatureFlag } from 'app/api/services/site-configs/types';

import { Scrollbar } from 'app/design-system/components/Scrollbar';
import { LanguageStore, useTranslation } from 'app/lang';
import { useFeatureFlag } from 'app/lib/feature-flags/useFeatureFlag';
import { getUniversalEnv } from 'app/lib/get-universal-env';
import useComponentWillMount from 'app/lib/hooks/useComponentWillMount';
import { ToggleThemeState, useTheme } from 'app/lib/theme';
import { createGaEvent, dispatchGaEvent } from 'app/packages/analytics';
import { getBrandName } from 'app/packages/brand';
import { cookie } from 'app/packages/lib';
import { MobileOS } from 'app/packages/lib/mobile/getOperationSystem';
import { SELECTED_LANGUAGE } from 'app/ssr/config';
import { BrandLogo } from 'app/widgets/BrandLogo';

import { AndroidInstruction } from './components/AndroidInstruction';
import { IOSInstruction } from './components/IOSInstruction';

import dictionary from './MobileLayout.dictionary.json';

import styles from './MobileLayout.module.scss';

type MobileLayoutProps = {
  os: MobileOS;
};

export const MobileLayout: FC<MobileLayoutProps> = ({ os }) => {
  const { t } = useTranslation();
  const { setTheme } = useTheme();
  const { replace }  = useHistory();
  const urlParams = new URLSearchParams(location.search);
  const isRedirectIosToAppStore = useFeatureFlag(FeatureFlag.REDIRECT_IOS_TO_APP_STORE);

  const mobileIosAppStoreUrl = getUniversalEnv('MOBILE_IOS_APP_STORE_URL');
  const isIos = os === 'iOS';

  useEffect(() => {
    // TODO: CP-934
    // Удалить когда будет по-умолчанию установлена системная тема на SSR
    setTheme(ToggleThemeState.SYSTEM);
  }, []);

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const fromParam = urlParams.get('from');

    const timeoutId = setTimeout(() => {
      if (fromParam) {
        dispatchGaEvent(createGaEvent({ event: 'launchFrom', eventValue: fromParam }));
      }
    }, 2000);

    replace({ search: '' });

    return () => {
      clearTimeout(timeoutId);
    };
  }, []);

  useComponentWillMount(() => {
    const langParam = urlParams.get('lang');

    if (langParam) {
      LanguageStore.changeLanguage(langParam);
      cookie.setCookie(SELECTED_LANGUAGE, langParam);
    }
  });

  if (isIos && isRedirectIosToAppStore && mobileIosAppStoreUrl){
    window.location.href = mobileIosAppStoreUrl;

    return;
  }

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <div className={styles.headerContent}>
          <BrandLogo width={104}
                     height={22} />
          <h1 className={styles.title}>
            {t(dictionary.title, { brand: capitalize(getBrandName()) })}
          </h1>
        </div>
      </div>
      <Scrollbar className={styles.scrollbar}>
        <div className={styles.instruction}>
          {isIos ? (
            <IOSInstruction />
          ) : (
            <AndroidInstruction />
          )}
        </div>
      </Scrollbar>
    </div>
  );
};
